import React from 'react'
import Typography, { TypographyProps } from '@material-ui/core/Typography'

interface IP2Prop {
  children: string
}
// default body text
export const P2 = ({ children, ...props }: TypographyProps & IP2Prop) => (
  <Typography variant="body1" {...props}>
    {children}
  </Typography>
)
